import { render, staticRenderFns } from "./CheckboxEditAreaComponent.vue?vue&type=template&id=a7218284&scoped=true&"
import script from "./CheckboxEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./CheckboxEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7218284",
  null
  
)

export default component.exports